import React, { useRef, ReactElement } from "react";
import UseIntersect from "./UseIntersect";

export interface Props {
    /** Your child element that you wish to observe */
    children: JSX.Element;
    /** Callback whenever your item is in view */
    onViewEnter?: () => void;
    /** on Click Action */
    onClick?: () => void;
    /** Element data test id */
    "data-testid"?: string;
    className?: string;
    options?: object;
    observerClassName?: string;
}

const ElementObserverOnceStart = (props: Props): ReactElement => {
    const { children, observerClassName, options, onViewEnter, ...otherProps } = props;
    const ref = useRef<HTMLDivElement | null>(null);

    const entry = UseIntersect({ elementRef: ref, options });

    if (entry) {
        if (entry.isIntersecting) {
            if (typeof onViewEnter === "function") {
                onViewEnter();
            }
        }
    }

    return (
        <div {...otherProps}>
            <div ref={ref} className={observerClassName} />
            {children}
        </div>
    );
};

export default ElementObserverOnceStart;
